<template>
  <div :class="{ 'iframe-mode': isInIframe }">
    <div class="pt-6 lg:pb-0 lg:pl-6 xl:pl-6 md:pl-6" v-if="windowResize.width > 200">
      <div class="flex flex-wrap w-full p-4" v-if="windowResize.width > 1023">
        <div class="not-italic font-normal text-zt-xl leading-8 flex items-center" :class="primaryTextClass">
          {{ $t('message.LicensesManager.landing.title') }}
        </div>
      </div>
      <div class="flex w-full p-4 md:flex-row flex-col content-div">
        <v-hover>
          <template v-slot="{ hover }">
            <v-card
              flat
              data-vs-link="toLicences"
              :elevation="hover ? 10 : 1" class="rounded top-card-width cursor-pointer flex md:flex-row flex-col pb-16 mr-2 items-center md:items-start"
              @click="$router.push('/licenses')"
            >
              <div class="md:w-5/12 text-center pt-10 md:pt-24">
                <div class="w-full md:ml-4">
                  <graphic-base :viewBox="'0 0 157 144'" class="mx-auto graphic-size">
                    <LicensesSVG />
                  </graphic-base>
                </div>
              </div>
              <div class="md:w-6/12 px-2 md:pt-16 text-center md:text-left">
                <div class="md:pl-4 text-zt-lg md:text-zt-xl text-zt-dark-600 md:text-zt-dark-400">
                  {{ $t('message.LicensesManager.landing.title_request') }}
                </div>
                <div class="md:pl-4 text-zt-lg text-zt-dark-300 margin-top md:w-11/12 padding-inline">
                  {{ $t('message.LicensesManager.landing.subtitle_request') }}
                </div>
                <div class="md:pl-4 text-zt-dark-500 mt-10" v-if="showInfo && !hasVPI">
                  <p class="text-zt-lg">{{ $t('message.LicensesManager.landing.info_request1', {availableDays}) }}</p>
                  <p v-if="showDetails" class="text-zt-md">{{ $t('message.LicensesManager.landing.info_request2', {licenseType}) }}</p>
                  <p v-else class="text-zt-md">{{ $t('message.LicensesManager.landing.info_request_registered', {licenseType}) }}</p>
                  
                </div>
              </div>
              <div class="w-1/12 pt-40" v-if="windowResize.width > 1023">
                <zt-icon name="angle-right-solid" />
              </div>
            </v-card>
          </template>
        </v-hover>
        <v-hover>
          <template v-slot="{ hover }">
            <v-card
              flat
              :elevation="hover ? 10 : 1" class="rounded top-card-width cursor-pointer flex md:flex-row flex-col pb-16 items-center md:items-start"
              @click="$router.push('/pending-approval')"
              data-vs-link="toPendingApproval"
            >
              <div class="md:w-5/12 text-center pt-10 md:pt-24">
                <div class="w-full md:ml-4">
                  <graphic-base :viewBox="'0 0 157 144'" class="mx-auto graphic-size">
                    <LicensesClockSVG />
                  </graphic-base>
                </div>
              </div>
              <div class="md:w-6/12 px-2 md:pt-16 text-center md:text-left">
                <div class="md:pl-4 text-zt-lg md:text-zt-xl text-zt-dark-600 md:text-zt-dark-400">
                  {{ $t('message.LicensesManager.landing.title_pending') }}
                </div>
                <div class="md:pl-4 text-zt-lg text-zt-dark-300 margin-top md:w-11/12 padding-inline">
                  {{ $t('message.LicensesManager.landing.subtitle_pending') }}
                </div>
                <div class="md:pl-4 text-zt-dark-500 mt-10" v-if="showInfo">
                  <span class="text-zt-lg">{{ $t('message.LicensesManager.landing.info_pending1', {pendingLicenses}) }}</span><br>
                  <span class="text-zt-md">{{ $t('message.LicensesManager.landing.info_pending2') }}</span>
                </div>
              </div>
              <div class="w-1/12 pt-40" v-if="windowResize.width > 1023">
                <zt-icon name="angle-right-solid" />
              </div>
            </v-card>
          </template>
        </v-hover>
      </div>
      <div class="flex flex-wrap w-full p-2" v-if="windowResize.width > 1023">
        <v-hover>
          <template v-slot="{ hover }">
            <v-card
              flat
              :elevation="hover ? 10 : 1" class="rounded bottom-card-width cursor-pointer bottom-card-mr flex-1"
              @click="$router.push('/licenses-search')"
              data-vs-link="toLicenceSearch"
            >
              <div class="flex flex-wrap">
                <div class="bg-white rounded-zt-sm flex flex-col items-center justify-center w-11/12 my-8">
                  <div class="icon-size" :class="primaryTextClass">
                    <zt-icon name="search-outline" />
                  </div>
                  <div class="mt-4 text-zt-lg text-zt-dark-400">
                    <span>{{ $t('message.LicensesManager.landing.title_licenses_search') }}</span>
                  </div>
                  <div class="mt-2 w-2/3 text-center">
                    <span class="text-zt-md text-zt-dark-300">
                      {{ $t('message.LicensesManager.landing.subtitle_licenses_search') }}
                    </span>
                  </div>
                </div>
                <div class="w-1/12 pt-24">
                  <zt-icon name="angle-right-solid" />
                </div>
              </div>
            </v-card>
          </template>
        </v-hover>
        <v-hover>
          <template v-slot="{ hover }">
            <v-card
             v-if="permissionOnButton('91')"
              flat
              :elevation="hover ? 10 : 1" class="rounded bottom-card-width cursor-pointer bottom-card-mr flex-1"
              @click="$router.push('/licenses-balances')"
              data-vs-link="toLicenceBalance"
            >
              <div class="flex flex-wrap">
                <div class="bg-white rounded-zt-sm flex flex-col items-center justify-center w-11/12 my-8">
                  <div class="icon-size" :class="primaryTextClass">
                    <zt-icon name="calendar" />
                  </div>
                  <div class="mt-4 text-zt-lg text-zt-dark-400">
                    <span>{{ $t('message.LicensesManager.landing.title_balances') }}</span>
                  </div>
                  <div class="mt-2 w-2/3 text-center">
                    <span class="text-zt-md text-zt-dark-300">
                      {{ $t('message.LicensesManager.landing.subtitle_balances') }}
                    </span>
                  </div>
                </div>
                <div class="w-1/12 pt-24">
                  <zt-icon name="angle-right-solid" />
                </div>
              </div>
            </v-card>
          </template>
        </v-hover>
        <v-hover>
          <template v-slot="{ hover }">
            <v-card
              flat
              :elevation="hover ? 10 : 1" class="rounded bottom-card-width cursor-pointer flex-1"
              @click="$router.push('/licenses-holidays')"
              v-if="permissionOnButton('92')"
              data-vs-textfield="toLicenceHolidays"
            >
              <div class="flex flex-wrap">
                <div class="bg-white rounded-zt-sm flex flex-col items-center justify-center w-11/12 my-8">
                  <div class="icon-size" :class="primaryTextClass">
                    <zt-icon name="palm-tree" />
                  </div>
                  <div class="mt-4 text-zt-lg text-zt-dark-400">
                    <span>{{ $t('message.LicensesManager.landing.title_nonworkingdays') }}</span>
                  </div>
                  <div class="mt-2 w-2/3 text-center">
                    <span class="text-zt-md text-zt-dark-300">
                      {{ $t('message.LicensesManager.landing.subtitle_nonworkingdays') }}
                    </span>
                  </div>
                </div>
                <div class="w-1/12 pt-24">
                  <zt-icon name="angle-right-solid" />
                </div>
              </div>
            </v-card>
          </template>
        </v-hover>
      </div>
    </div>
    <div v-else>
      <RedirectFromManager />
    </div>
  </div>
</template>

<script>
import graphicBase from '@/components/commons/Illustrations/graphicBase'
import LicensesSVG from '@/components/commons/Illustrations/graphicSVG/LicensesSVG'
import LicensesClockSVG from '@/components/commons/Illustrations/graphicSVG/LicensesClockSVG'
import Licenses from '@/apiClient/Licenses'
import { mapGetters, mapActions, mapState } from "vuex"
import { useWindowResize } from '@sichern/ui-elements'
import RedirectFromManager from './RedirectFromManager'
import { forEach } from 'lodash'
import trunc from '@/utils/trunc.js'

export default {
  name: 'ManagerLanding',
  components: {
    graphicBase,
    LicensesSVG,
    LicensesClockSVG,
    RedirectFromManager
  },
  data() {
    return {
      licenses: Licenses,
      licenseType: '',
      availableDays: 0,
      pendingLicenses: 0,
      showInfo: false,
      windowResize: useWindowResize(this),
      showDetails: null
    }
  },
  computed: {
    ...mapGetters({
      getUser: 'getUser'
    }),
    ...mapState('licenses', ['pendingApproval']),
    hasVPI() {
        return this.$store.state.hasIntegrationSichernPeople;
    },
    isInIframe() {
      return this.$iframeMessages && this.$iframeMessages.isTokenValid();
    },
    primaryTextClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-200';
    }
  },
  async created(){
    window.scrollTo(0, 0)
    this.licenses = new Licenses()
    const getLicencesResponse = await this.licenses.getLicenseTypes()
    const {
      data: { data }
    } = getLicencesResponse
    let vacationId = ''
    forEach(data, type => {
      if(type.isVacation){
        vacationId = type.id
        this.licenseType = type.nombre
        return false
      }
    })
    const { available, show_details } = (await this.licenses.getBalanceByType(vacationId)).data.results.data[0];
    this.availableDays = trunc(available);
    this.showDetails = show_details;
    let idUser = this.getUser.id;
    await this.setPendingApproval({idUser});
    this.pendingLicenses = this.pendingApproval.length
    this.showInfo = true
  },
  methods: {
    ...mapActions('licenses', ['setPendingApproval']),
    permissionOnButton(id) {
			if (!this.$store.state.actions) return false

			if (this.$store.state.actions.length > 0) {
				if (this.$store.state.actions.map(act => act.id).includes(id)) return true
			}

			return false;
		},
  }
}
</script>

<style lang="scss" scoped>
.icon-size {
  font-size: 2.5rem;
}

@media screen and (min-width: 600px) {
  .top-card-width {
    width: 45%;
  }
  .graphic-size{
    height: 80%;
    width: 80%;
  }
  .margin-top{
    margin-top:2.5rem;
  }
}

@media screen and (max-width: 769px) {
  .top-card-width {
    width: 95%;
    margin-left:0.5rem;
  }
  .graphic-size{
    height: 60%;
    width: 60%;
  }
  .content-div {
    gap:20px
  }
  .margin-top{
    margin-top:1rem;
  }
  .padding-inline{
    padding: 0 2rem;
  }
}
.bottom-card-width {
  width: 32%;
}
.bottom-card-mr {
  margin-right: 2%;
}

/* =========================================
   ESTILOS ESPECÍFICOS PARA MODO IFRAME
   Solo afecta a este componente cuando está en iframe
   ========================================= */
.iframe-mode {
  /* Variables CSS locales para iframe */
  --primary-color: #2694fc;
  --branding-primary: #2694fc;
  --v-primary-base: #2694fc;
  --branding-titleColor: #2694fc;
  --branding-textColor: #2694fc;
  --branding-lightThemeBg: #2694fc;
  
  /* Override SOLO de clases con color primario/morado (#4f41a3) */
  ::v-deep .text-zt-primary-200,
  ::v-deep .text-zt-primary-100,
  ::v-deep .text-zt-primary-600,
  ::v-deep .text-purple-600 {
    color: #2694fc !important;
  }
  
  /* Override de fondos primarios */
  ::v-deep .bg-zt-primary-200 {
    background-color: #2694fc !important;
  }
  
  /* Override de bordes primarios */
  ::v-deep .border-zt-primary-200 {
    border-color: #2694fc !important;
  }
  
  /* Override para iconos con clase primaria */
  ::v-deep .zt-icon {
    &.text-zt-primary-200,
    &.text-zt-primary-100,
    &.text-purple-600 {
      color: #2694fc !important;
    }
  }
  
  /* Override específico para iconos dentro de .icon-size */
  ::v-deep .icon-size {
    color: #2694fc !important;
    
    .zt-icon,
    i {
      color: #2694fc !important;
    }
  }
  
  /* Override para elementos con atributos que contengan clases primarias */
  ::v-deep [class*="text-purple-600"],
  ::v-deep [class*="text-zt-primary-100"],
  ::v-deep [class*="text-zt-primary-200"],
  ::v-deep [class*="text-zt-primary-600"] {
    color: #2694fc !important;
  }
}

/* Clase helper para texto primario en iframe */
.text-iframe-primary {
  color: #2694fc !important;
}

</style>
